import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Facebook, Twitter, ArrowRight } from 'lucide-react';
import { company, navLinks } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-fx-navy text-fx-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2.5 mb-5">
            <div className="relative w-10 h-10 rounded-md bg-white/5 border border-white/10 flex items-center justify-center">
              <span className="font-display text-fx-gold text-2xl leading-none">F</span>
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-display text-white text-xl font-bold">Foxstone</span>
              <span className="text-[10px] tracking-[0.22em] text-fx-gold font-semibold uppercase">Funding</span>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            An independent Canadian finance company providing equipment leasing, working capital and refinancing solutions nationwide.
          </p>
          <div className="flex gap-3 mt-6">
            {[Linkedin, Facebook, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-white/15 flex items-center justify-center hover:bg-fx-gold hover:border-fx-gold hover:text-fx-navy transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-fx-gold mb-5">Navigate</h4>
          <ul className="space-y-3 text-sm">
            {navLinks.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-white/75 hover:text-fx-gold transition-colors inline-flex items-center gap-1.5 group">
                  <ArrowRight className="w-3.5 h-3.5 opacity-0 -ml-5 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-fx-gold mb-5">Financing</h4>
          <ul className="space-y-3 text-sm text-white/75">
            <li>Equipment Leasing</li>
            <li>Working Capital Loans</li>
            <li>Sale-Leaseback</li>
            <li>Vendor Programs</li>
            <li>Mortgage Refinancing</li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-fx-gold mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-fx-gold shrink-0" /><span>{company.address}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-fx-gold shrink-0" /><a href={`tel:${company.phone}`} className="hover:text-fx-gold">{company.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-fx-gold shrink-0" /><a href={`mailto:${company.email}`} className="hover:text-fx-gold">{company.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <p>© {new Date().getFullYear()} Foxstone Funding. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-fx-gold">Privacy Policy</a>
            <a href="#" className="hover:text-fx-gold">Terms of Service</a>
            <a href="#" className="hover:text-fx-gold">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
